import enums from '../enums/RdsLife.enums';
export default class CalendarEvent {
  constructor({ id, name, dateStart, dateEnd, icon, likes, description, color, location, users }) {
    this.id = id;
    this.name = name;
    this.dateStart = dateStart;
    this.dateEnd = dateEnd;
    this.icon = icon;
    this.likes = [];
    this.description = description;
    this.color = color;
    this.location = location || '';
    this.tipologia = enums.modelTypes.CALENDAR_EVENT;
    if (!!users) {
      let usersLike = users.filter(u => u.likes.events.indexOf(this.id) !== -1).map(u => u.id);
      this.likes = usersLike;
    }
  }
}
